export default __webpack_public_path__ + "static/media/poultry_cat_disabled.f59ea727.png";